/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Utils for Response Screen of Claim Status
 */
import _ from 'lodash';

import { CLAIM_STATUS_CODES_MAPPING } from 'app-constants/claims';

const dataKeys = {
	payerIds: 'payerid',
	identifier: 'identifier',
	patientName: 'patientName',
	dateOfService: 'serviceDates',
	claimNumber: 'claimNumber',
	dateOfBirth: 'dob',
	status: 'status',
	// custom
	startDate: 'startDate',
	endDate: 'endDate',
};

const dataKeyLabels = {
	payerId: 'Payer',
	patientIdentifier: 'Patient Identifier',
	patientName: 'Patient Name',
	serviceDates: 'Service Dates',
	serviceDate: 'Service Date',
	claimNumber: 'Claim Number',
	dob: 'Date of Birth',
	// filter params
	providerIds: 'Provider/Organization',
	claimStatus: 'Claim Status',
	claimAmount: 'Billed',
	claimAge: 'Claim Age',
	claimId: 'Claim ID',
	sortBy: 'Sort By',
	locationId: 'Service Location',
	workState: 'Claim State',
	guarantorName: 'Guarantor Name',
	accountNumber: 'Account ID',
};

const mapClaimStatusLabelToCodes = (labels?: string[]): string[] => {
	return _.flatMap(labels, (label) => _.get(CLAIM_STATUS_CODES_MAPPING, label));
};

const mapClaimStatusCodesToLabels = (codes?: string[]): string[] => {
	return _.keys(_.pickBy(CLAIM_STATUS_CODES_MAPPING, (group) => !_.isEmpty(_.intersection(group, codes))));
};

// check if a payer supports claim status
const isClaimStatusPayer = (data: ClaimRequest.IClaim, selectedPayers: Payers.ISelectedPayer[]): boolean => {
	const tenantPayerId = _.split(data?.fhirResource?.insurer?.reference, '/')?.[1];
	return _.find(selectedPayers, { id: tenantPayerId })?.isClaimStatus;
};

const isEligibilityPayer = (data: ClaimRequest.IClaim, selectedPayers: Payers.ISelectedPayer[]): boolean => {
	const tenantPayerId = _.split(data?.fhirResource?.insurer?.reference, '/')?.[1];
	return _.find(selectedPayers, { id: tenantPayerId })?.isEligibility;
};

export { dataKeys, dataKeyLabels, mapClaimStatusLabelToCodes, mapClaimStatusCodesToLabels, isClaimStatusPayer, isEligibilityPayer };
